<div class="container-fluid p-2">
  <form novalidate>
    <div class="row">
      <div class="col-3">
        <label>
          Status:
        </label>
        <div class="mb-3">
          <ng-select
            class="w-100"
            bindValue="value"
            bindLabel="display"
            name="statuses"
            placeholder="Filter by Status"
            [multiple]="true"
            [items]="taskStatuses"
            (remove)="onFilterChange()"
            (change)="onFilterChange()"
            [(ngModel)]="filters.selectedStatuses"
            [disabled]="loading"
            />
        </div>
      </div>

      <div class="col-3">
        <label>
          Sources:
        </label>
        <div class="mb-3">
          <ng-select
            class="w-100"
            name="sources"
            placeholder="Filter by Source"
            [multiple]="true"
            [items]="sources"
            (remove)="onFilterChange()"
            (change)="onFilterChange()"
            [(ngModel)]="filters.selectedSources"
            [disabled]="loading"
            />
        </div>
      </div>

      @if (useEstimatedValueRanks) {
        <div class="col-3">
          <label>Estimated Values:</label>
          <div class="mb-3">
            <ng-select
              class="w-100"
              bindValue="value"
              bindLabel="display"
              name="estimatedValues"
              placeholder="Filter by Estimated Value"
              [multiple]="true"
              [items]="estimatedValueRank"
              (remove)="onFilterChange()"
              (change)="onFilterChange()"
              [(ngModel)]="filters.selectedEstimatedValues"
              [disabled]="loading"
              />
          </div>
        </div>
      } @else {
        <div class="col-3">
          <label>Estimated Value Min.</label>
          <div class="input-group estimated-value">
            <div class="input-group-prepend"><span class="input-group-text">$</span></div>
            <input
              [(ngModel)]="filters.estimatedValue"
              name="estimatedValue"
              [ngClass]="{ 'has-value': hasEstimatedValue }"
              (keydown)="onEstimatedValueKeyDown($event)"
              (keyup)="onEstimatedValueKeyUp()"
              class="form-control pe-0"
              placeholder="e.g. 1000"
              [disabled]="loading"
              />
            @if (hasEstimatedValue) {
              <div class="input-group-append">
                <button class="btn btn-outline-secondary py-0" type="button" (click)="onClearEstimatedValueClick()">
                  <span class="btn-label">×</span>
                </button>
              </div>
            }
          </div>
        </div>
      }

      <div class="col-3">
        <label>Specialties:</label>
        <div class="mb-3">
          <ng-select
            class="w-100"
            name="specialties"
            placeholder="Filter by Specialties"
            [multiple]="true"
            [items]="specialties"
            (remove)="onFilterChange()"
            (change)="onFilterChange()"
            [(ngModel)]="filters.selectedSpecialties"
            [disabled]="loading"
            />
        </div>
      </div>

      <div class="col-3">
        <label>Prescriber First Name:</label>
        <div class="mb-3">
          <input
            type="text"
            class="w-100 border rounded px-2"
            name="prescriberFirstName"
            [(ngModel)]="filters.prescriberFirstName"
            (input)="onTextFieldChange()"
            [disabled]="loading">
        </div>
      </div>
      <div class="col-3">
        <label>Prescriber Last Name:</label>
        <div class="mb-3">
          <input
            type="text"
            class="w-100 border rounded px-2"
            name="prescriberLastName"
            [(ngModel)]="filters.prescriberLastName"
            (input)="onTextFieldChange()"
            [disabled]="loading">
        </div>
      </div>

      <div class="col-3">
        <label>Prescriber NPI:</label>
        <div class="mb-3">
          <input
            type="text"
            class="w-100 border rounded px-2"
            name="prescriberNpi"
            [(ngModel)]="filters.prescriberNpi"
            (input)="onTextFieldChange()"
            [disabled]="loading">
        </div>
      </div>

      <div class="col-3">
        <label>Manufacturer:</label>
        <div class="mb-3">
          <ng-select
            class="w-100"
            name="manufacturer"
            placeholder="Filter by Manufacturer"
            [multiple]="true"
            [items]="manufacturers"
            (remove)="onFilterChange()"
            (change)="onFilterChange()"
            [(ngModel)]="filters.selectedManufacturers"
            [disabled]="loading" />
        </div>
      </div>

      <div class="col-3">
        <label>Patient First Name:</label>
        <div class="mb-3">
          <input
            type="text"
            class="w-100 border rounded px-2"
            name="patientFirstName"
            [(ngModel)]="filters.patientFirstName"
            (input)="onTextFieldChange()"
            [disabled]="loading">
        </div>
      </div>
      <div class="col-3">
        <label>Patient Last Name:</label>
        <div class="mb-3">
          <input
            type="text"
            class="w-100 border rounded px-2"
            name="patientLastName"
            [(ngModel)]="filters.patientLastName"
            (input)="onTextFieldChange()"
            [disabled]="loading">
        </div>
      </div>

      @if (encounterPatientInteractionLocations) {
        <div class="col-3">
          <label>Locations:</label>
          <div class="mb-3">
            <app-client-select
              name="clients"
              placeholder="Filter by Clients"
              [multiple]="true"
              [clients]="clients"
              [(selectedIds)]="filters.selectedClientIds"
              (changed)="onFilterChange()"
              [disabled]="loading"
            />
          </div>
        </div>
      }

      @if (clients) {
        <div class="col-3">
          <label>Clients:</label>
          <div class="mb-3">
            <app-client-select
              name="clients"
              placeholder="Filter by Clients"
              [multiple]="true"
              [clients]="clients"
              [(selectedIds)]="filters.selectedClientIds"
              (changed)="onFilterChange()"
              [disabled]="loading"
            />
          </div>
        </div>
      }

      @if (allowTaskIdSearch) {
        <div class="col-3">
          <label>Task ID:</label>
          <div class="mb-3">
            <input
              type="text"
              class="w-100 border rounded px-2"
              name="taskId"
              [(ngModel)]="filters.taskId"
              (input)="onTextFieldChange()"
              [disabled]="loading">
          </div>
        </div>
      }

      <div class="col-3">
        <div class="row">
          <div class="col-6">
            <label>Days To Expiration:</label>
            <div class="mb-3">
              <input
                type="number"
                class="w-100 border rounded px-2"
                name="expiringWithinDays"
                appExcludeInputPattern
                excludedPattern="\D"
                maxlength="3"
                [(ngModel)]="filters.expiringWithinDays"
                (input)="onTextFieldChange()"
                [disabled]="loading">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-end">
        <div class="mb-3 mt-2">
          <button type="button" class="btn btn-info mt-0 clear-button" (click)="onClearFiltersClick()">Clear Filters</button>
          @if (exportUrl) {
            @if (enableExport) {
              <a class="btn btn-primary"
                routerLinkActive="active"
                routerLink="{{ exportUrl }}"
                >
                Export
              </a>
            } @else {
              <button type="button" class="btn btn-primary" [disabled]="true">Export</button>
            }
          }
        </div>
      </div>
    </div>
  </form>
</div>
